import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import BillTable from "../../BillTableView";

const CustomerandSupplierinfo = (props) => {
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("bookingcosting");
  const [customerList, setCustomerList] = useState(undefined);
  const [rateList, setRateList] = useState(undefined);
  const [curruncyList, setCurruncyList] = useState(undefined);
  const [supplierList, setSupplierList] = useState(undefined);
  const [tableItems, setTableItems] = useState([]);
  const [selectedTbaleRowID, setSelectedTbaleRowID] = useState("");

  const [customer, setCustomer] = useState("");
  const [rate, setRate] = useState("");
  const [currency, setcurrency] = useState("");
  const [exRate, setEXRate] = useState("");
  const [cost, setCost] = useState(props.valueToCost);
  const [quoat, setQuoat] = useState("");
  const [rRate, setRRate] = useState("");
  const [cDate, setCDate] = useState("");
  const [volume, setVolume] = useState("");

  const [custName, setcustName] = useState("");
  const [supName, setSupName] = useState("");
  const [supCode, setSupCode] = useState("");
  const [currentRRate, setCurrentRRate] = useState("");
  const [currencyName, seturrencyName] = useState("");

  const [vatLIst, setVatLIst] = useState([]);
  const [totalCost, setTotalCost] = useState("");
  const [taxList, setTaxList] = useState(undefined);

  const valueToCostHadle = (event) => {
    props.handleChangeCost(event.target.value);
    setCost(event.target.value);
  };

  const valueToExRateHadle = (event) => {
    props.onhandleExRate(event.target.value);
    setEXRate(event.target.value);
  };

  const valueToSupplierHadle = (event) => {
    props.onhandleSupplier(event.target.value);
    setSupCode(event.target.value);
    supplierList.forEach((supplierItem) => {
      if (supplierItem.Vendor_id === event.target.value) {
        props.onhandleSupplierName(supplierItem.Vendor_name);
        setSupName(supplierItem.Vendor_name);
      }
    });
  };

  const valueToCustomerHadle = (event) => {
    props.onhandleCustCode(event.target.value);
    setCustomer(event.target.value);
    customerList.forEach((currCust) => {
      if (currCust.Cus_id === event.target.value) {
        props.onhandleCustomerName(currCust.Cus_name);
        setcustName(currCust.Cus_name);
      }
    });
  };

  const valueToRateHadle = (event) => {
    props.onhandleRateCode(event.target.value);
    setRate(event.target.value);
    rateList.forEach((rateitem) => {
      if (rateitem.RateCode === event.target.value) {
        props.onhandleRate(rateitem.RateDesc);
        setCurrentRRate(rateitem.RateDesc);
      }
    });
  };

  const valueToCurruncyHadle = (event) => {
    props.onhandleCurrencyCode(event.target.value);
    setcurrency(event.target.value);
    curruncyList.forEach((currencyItem) => {
      if (currencyItem.CurrCode === event.target.value) {
        props.onhandleCurrencyDesc(currencyItem.CurrDesc);
        seturrencyName(currencyItem.CurrDesc);
      }
    });
  };

  const valueToQuoatHadle = (event) => {
    props.onhandleQuoat(event.target.value);
    setQuoat(event.target.value);
  };

  const valueToRateRemakeHadle = (event) => {
    props.onhandleRRate(event.target.value);
    setRRate(event.target.value);
  };

  const valueToCreditDaysHadle = (event) => {
    props.onhandleCDate(event.target.value);
    setCDate(event.target.value);
  };

  const valueToCreditVolumeHadle = (event) => {
    props.onhandleVolume(event.target.value);
    setVolume(event.target.value);
  };
  const setVAT = (event) => {
    if (event.target.checked === true) {
      setVatLIst([...vatLIst, event.target.id]);
    }

    if (event.target.checked === false) {
      const updatedArray = vatLIst.filter((item) => item !== event.target.id);
      setVatLIst(updatedArray);
    }
  };

  const setTableValue = async () => {
    let totCost = totalCost;
    let qouted = quoat * 1;
    let totalNBTQuote = 0;
    let totNBT = 0;
    let nbtPrec = 0;
    let vatPrec = 0;
    let percentage = 0;
    let totalVATQuote = 0;
    let totVATItem1 = 0;
    // let allTotalCost = 0;

    totCost = exRate * volume * cost;
    qouted = exRate * volume * quoat;
    // allTotalCost = allTotalCost + totCost;
    vatLIst.forEach((vatItem) => {
      taxList.forEach((elementitem) => {
        if (elementitem.Tax === vatItem) {
          if (elementitem.TaxRate > 0) {
            percentage = elementitem.TaxRate / 100;
          } else {
            percentage = 0;
          }
          if (vatItem === "NBT") {
            totNBT = exRate * volume * cost * percentage;
            totalNBTQuote = exRate * volume * qouted * percentage;

            nbtPrec = percentage;
          } else if (vatItem === "VAT") {
            totVATItem1 =
              (exRate * volume * cost + totNBT) * (elementitem.TaxRate / 100);
            totalVATQuote =
              (exRate * volume * qouted + totalNBTQuote) *
              (elementitem.TaxRate / 100);

            vatPrec = elementitem.TaxRate / 100;
          }
        }
      });
    });

    let difference = qouted - totCost;
    setTotalCost(totCost);

    appndTableValue(
      totCost,
      qouted,
      difference,
      totNBT,
      totalNBTQuote,
      nbtPrec,
      vatPrec,
      totVATItem1,
      totalVATQuote
    );

    props.handleTotalCost(
      calculateTotalCost() + calculateTotalVAT() > 0
        ? calculateTotalCost() + calculateTotalVAT()
        : props.valueTotalCost
    );

    props.onhandleTotalVAT(calculateTotalVAT());
    props.handleTotalQuote(calculateTotalQuote());
    props.onhandleTotalVATQoute(calculateTotalVATQuote());
    props.handleTotalDifference(calculateTotalDifference());
  };

  const calculateTotalCost = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.TotalCost * 1,
      0
    );
  };

  const calculateTotalVAT = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.TotalVATQoute * 1,
      0
    );
  };

  const calculateTotalNBT = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.TotalNBT * 1,
      0
    );
  };

  const calculateTotalQuote = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.TotalQuote * 1,
      0
    );
  };

  const calculateTotalVATQuote = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.TotalVATQoute * 1,
      0
    );
  };

  const calculateTotalDifference = () => {
    return props.tabledata.reduce(
      (total, tabledata) => total + tabledata.Difference * 1,
      0
    );
  };

  const appndTableValue = async (
    totCost,
    qouted,
    difference,
    totNBT,
    totalNBTQuote,
    nbtPrec,
    vatPrec,
    totVATItem1,
    totalVATQuote,
    totAmount
  ) => {
    const updateTableVal = {
      CustName: custName,
      customer: customer,
      RateName: currentRRate,
      RateCode: rate,
      Currency: currencyName,
      CurrCode: currency,
      TotalNBT: totNBT,
      NBTPrecentage: nbtPrec,
      TotalNBTQuote: totalNBTQuote,
      TotalVATQoute: totalVATQuote,
      VATPrecentage: vatPrec,
      TotalVAT: totVATItem1,
      ExRate: props.valueToExRate ? props.valueToExRate : exRate,
      TotalCost: totCost,
      Cost: props.valueToCost ? props.valueToCost : cost,
      Difference: difference,
      Quoat: quoat,
      TotalQuote: qouted,
      SupplierName: supName,
      SupplierCode: props.valueToSupCode ? props.valueToSupCode : supCode,
      rRate: rRate,
      CreditDays: cDate,
      Volume: volume,
    };
    const updateTableLIst = props.tabledata.concat(updateTableVal);
    props.hadleTableDataset(updateTableLIst);
    setTableItems(updateTableLIst);
    // console.log(updateTableLIst);
  };

  const RemoveSelectedDataRow = async () => {
    const updateTableLIst = tableItems.splice(selectedTbaleRowID);
    setTableItems(updateTableLIst);
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/customerdropdown`)
      .then((response) => response.json())
      .then((data) => {
        setCustomerList(data.customer);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}tax/index`)
      .then((response) => response.json())
      .then((data) => {
        setTaxList(data.tax);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/ratedropdown`)
      .then((response) => response.json())
      .then((data) => {
        setRateList(data.rate);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/currencydropdown`)
      .then((response) => response.json())
      .then((data) => {
        setCurruncyList(data.currency);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/supplierdropdown`)
      .then((response) => response.json())
      .then((data) => {
        setSupplierList(data.supplier);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  function setSelectedRow(rowid, row) {
    const selectedCustomer = customerList.filter(
      (item) => item.Cus_name === row.CustName
    );
    props.onhandleCustCode(selectedCustomer[0].Cus_id);
    props.onhandleCustomerName(row.CustName);
    props.onhandleCurrencyCode(row.CurrCode);
    props.onhandleCurrencyDesc(row.Currency);
    props.onhandleRate(row.RateName);
    props.onhandleRateCode(row.RateCode);
    props.onhandleExRate(row.ExRate);
    props.onhandleVolume(row.Volume);
    props.handleChangeCost(row.Cost);
    props.onhandleQuoat(row.Quoat);
    props.onhandleSupplierName(row.SupplierName);
    props.onhandleSupplier(row.SupplierCode);
    props.onhandleRRate(row.rRate);
    props.onhandleCDate(row.CreditDays);
    setSelectedTbaleRowID(rowid);
  }

  const headercolumns = [
    "CustName",
    "Rate",
    "Currency",
    "ExRate",
    "Volume",
    "Cost",
    "Quoat",
    "TotalCost",
    "TotalQuote",
    "RateCode",
    "Difference",
    "CreditDays",
    "SupplierName",
    "TotalNBT",
    "TotalVAT",
    "TotalNBTQuote",
    "TotalVATQoute",
    "NBTPrecentage",
    "VATPrecentage",
  ];
  const columns = [
    "CustName",
    "RateName",
    "Currency",
    "ExRate",
    "Volume",
    "Cost",
    "Quoat",
    "TotalCost",
    "TotalQuote",
    "RateCode",
    "Difference",
    "CreditDays",
    "SupplierName",
    "TotalNBT",
    "TotalVAT",
    "TotalNBTQuote",
    "TotalVATQoute",
    "NBTPrecentage",
    "VATPrecentage",
  ];

  return (
    <div className="d-flex flex-column ">
      {/* <input type="text" value={selectedBookingNO} onChange={setSelectedBookingItem()} /> */}
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Customer </Form.Label>
            <Form.Select
              aria-label="Default select"
              value={props.valueToCustCode}
              onChange={valueToCustomerHadle}
            >
              {props.valueToCustName ? (
                <option value={props.valueToCustCode}>
                  {props.valueToCustName}
                </option>
              ) : (
                ""
              )}
              {customerList !== undefined
                ? customerList.map((customerItem, id) => (
                    <option value={customerItem.Cus_id} key={id}>
                      {customerItem.Cus_name}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Rate </Form.Label>
            <Form.Select
              aria-label="Default select"
              value={props.valueToRateCode}
              onChange={valueToRateHadle}
            >
              {rate ? (
                <option value={props.valueToRateCode}>
                  {props.valueToRate}
                </option>
              ) : (
                ""
              )}

              {rateList !== undefined
                ? rateList.map((rateItem, id) => (
                    <option value={rateItem.RateCode} key={id}>
                      {rateItem.RateDesc}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>currency </Form.Label>
            <Form.Select
              aria-label="Default select"
              value={props.valueToCurrCode}
              onChange={valueToCurruncyHadle}
            >
              {currency ? (
                <option value={props.valueToCurrCode}>
                  {props.valueToCurrDesc}
                </option>
              ) : (
                ""
              )}

              <option></option>
              {curruncyList !== undefined
                ? curruncyList.map((curruncytem, id) => (
                    <option value={curruncytem.CurrCode} key={id}>
                      {curruncytem.CurrDesc}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Exchange Rate</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="totvolume"
              value={props.valueToExRate}
              onChange={valueToExRateHadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Cost</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="totvolume"
              value={props.valueToCost}
              onChange={valueToCostHadle}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Quote</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="totvolume"
              value={props.valueToQuoat}
              onChange={valueToQuoatHadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Supplier</Form.Label>
            <Form.Select
              aria-label="Default select"
              value={props.valueToSupCode}
              onChange={valueToSupplierHadle}
            >
              {props.valueToSupCode ? (
                <option value={props.valueToSupCode}>
                  {props.valueToSupName}
                </option>
              ) : (
                ""
              )}

              {supplierList !== undefined
                ? supplierList.map((supplieritem, id) => (
                    <option value={supplieritem.Vendor_id} key={id}>
                      {supplieritem.Vendor_name}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Rate Remark </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="remark"
              value={props.valueToRateRemake}
              onChange={valueToRateRemakeHadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Credit Days </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="creditdays"
              value={props.valueToCreditDays}
              onChange={valueToCreditDaysHadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Volume</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="valume"
              value={props.valueToVolume}
              onChange={valueToCreditVolumeHadle}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        {taxList !== undefined
          ? taxList.map((taxItem) =>
              taxItem.Active === 1 ? (
                <Col key={taxItem.id}>
                  <Form.Group className="mb-3" controlId="">
                    <Form.Check
                      type="checkbox"
                      label={taxItem.Tax}
                      id={taxItem.Tax}
                      onChange={setVAT}
                    />
                  </Form.Group>
                </Col>
              ) : (
                ""
              )
            )
          : ""}
        <Col>
          <Button
            className="ms-3"
            variant="primary"
            onClick={setTableValue}
            type="submit"
          >
            Add
          </Button>
          <Button
            className="ms-3"
            variant="primary"
            onClick={RemoveSelectedDataRow}
            type="submit"
          >
            Cancel
          </Button>
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col className="mt-3">
          <BillTable
            data={props.tabledata ? props.tabledata : ""}
            columns={columns}
            headercolumns={headercolumns}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>
              Total cost{" "}
              {calculateTotalCost() + calculateTotalVAT() > 0
                ? (calculateTotalCost() + calculateTotalVAT()).toFixed(2)
                : props.valueTotalCost}
            </Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>NBT {calculateTotalNBT().toFixed(2)}</Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>VAT {calculateTotalVAT().toFixed(2)}</Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>
              Total Quote {calculateTotalQuote().toFixed(2)}
            </Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>
              Total VAT Quote {calculateTotalVATQuote().toFixed(2)}
            </Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-1" controlId="formGroupEmail">
            <Form.Label>
              Difference {calculateTotalDifference().toFixed(2)}
            </Form.Label>
          </Form.Group>
        </Col>
      </Row>
      {/* <button className="button" onClick={handleContainerCUS}>Save</button> */}
    </div>
  );
};

export default CustomerandSupplierinfo;
